import {
    Button,
    Dialog,
    DialogContent,
    Grid,
    Paper,
    Typography,
    makeStyles,
    Divider,
    Box
} from '@material-ui/core';
import { PrinterIcon } from '../../icons';
import { formatPhone } from '../../helpers/phoneUtils';
import ItineraryTable from '../profile/ItineraryTable';
import { useRef } from 'react';

const PRINT_STYLES = `
  :root {
    --gray-100:#f3f4f6;
    --gray-200:#e5e7eb;
    --gray-300:#d1d5db;
    --gray-700:#374151;
    --black:#111827;
  }
  @page { margin: 16mm; }
  * { box-sizing: border-box; }
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
    color: var(--black);
    margin: 0;
    padding: 15px;
  }
  .container { width: 100%; }
  .MuiGrid-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
}
    .MuiGrid-item {
    margin: 0;
    box-sizing: border-box;
}
        .MuiGrid-grid-sm-6 {
        flex-grow: 0;
        max-width: 50%;
        flex-basis: 50%;
    }
    .MuiPaper-root {
    color: rgba(0, 0, 0, 0.87);
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    background-color: #fff;
}
    button, .MuiButton-root {
        display: none !important;
    }

    .MuiDivider-root{
        display:none !important;
    }

    .MuiBackdrop-root{
        display:none !important;
    }
    .MuiDialog-root{
        position: relative !important;
    }
    .MuiDialog-paper{
        max-width: auto !important;
        box-shadow: none !important;
        width: 100% !important;
    }

    .MuiDialog-scrollPaper{
        align-items: initial !important;
    }
        .MuiDialogContent-root{
        overflow: visible !important;
        }

    .hide-in-print {
        display: none !important;
    }

    .show-in-print {
        display: table-row !important;
    }
`;

const useStyles = makeStyles(() => ({
    paper: {
        borderRadius: 16,
        overflow: 'visible',
        boxShadow: '0 12px 32px rgba(0,0,0,.18)'
    },
    titleBar: {
        display: 'flex',
        alignItems: 'center',
        padding: '16px 20px 8px'
    },
    title: {
        fontWeight: 800,
        fontSize: 24,
        color: '#0b1723'
    },
    topCard: {
        padding: 16,
        border: '1px solid #e6e6e6',
        borderRadius: 8
    },
    sectionTitle: {
        fontWeight: 700,
        color: '#0b1723',
        marginBottom: 8
    },
    label: { color: '#6b7280', width: 120 },
    value: { fontWeight: 600, marginBottom: 10 },
    actions: { padding: '8px 16px 16px', gap: 20, display: 'flex', justifyContent: 'flex-end' }
}));

const TestItineraryModal = ({
    showModal,
    MODAL_TYPE,
    bookingsData,
    customer,
    customerArrival,
    customerDeparture
}) => {
    const classes = useStyles();
    const dialogRef = useRef(null);
    const { itemsToBook, bookingItemsCount, grandTotal, taxesAndFees, discount } = bookingsData;

    return (
        <Dialog
            aria-labelledby="testitinerary-modal"
            open
            onClose={() => showModal(MODAL_TYPE.NONE)}
            maxWidth="md"
            fullWidth
            PaperProps={{ classes: { root: classes.paper } }}
            ref={dialogRef}
        >
            <Box className={classes.titleBar}>
                <Typography className={classes.title}>Guest itinerary</Typography>
            </Box>
            <DialogContent>
                <Paper elevation={0} className={classes.topCard} style={{ marginBottom: 16 }}>
                    <Typography item className={classes.sectionTitle}>
                        Guest information
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={0}>
                                <Grid item className={classes.label}>
                                    Guest:
                                </Grid>
                                <Grid item className={classes.value}>
                                    {customer?.firstname + ' ' + customer?.lastname}
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item className={classes.label}>
                                    Phone:
                                </Grid>
                                <Grid item className={classes.value}>
                                    {formatPhone(customer?.phone)}
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item className={classes.label}>
                                    Email:
                                </Grid>
                                <Grid item className={classes.value}>
                                    {customer?.email}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography className={classes.sectionTitle}> </Typography>
                            <Grid container spacing={0}>
                                <Grid item className={classes.label}>
                                    Arrival date:
                                </Grid>
                                <Grid item className={classes.value}>
                                    {customerArrival}
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item className={classes.label}>
                                    Departure date:
                                </Grid>
                                <Grid item className={classes.value}>
                                    {customerDeparture}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
                <ItineraryTable
                    itemsToBook={itemsToBook}
                    bookingItemsCount={bookingItemsCount}
                    grandTotal={grandTotal}
                    taxesAndFees={taxesAndFees}
                    discount={discount}
                    showFeeAndActivity
                />
            </DialogContent>
            <Divider />
            <Box className={classes.actions}>
                <Button
                    onClick={() => {
                        const allJssCss = Array.from(
                            document.querySelectorAll('style[data-jss]') // MUI v4 + JSS
                        )
                            .map(styleTag => styleTag.textContent || '')
                            .join('\n');

                        const blob = new Blob(
                            [
                                `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Itinerary</title>`,
                                `<style>${PRINT_STYLES}</style>`,
                                `<style>${allJssCss}</style>`,
                                `</head><body><div class="container">`,
                                dialogRef.current.outerHTML,
                                `</div><script>
                                        (function(){
                                        let opened = false;
                                        const printNow = () => { if (!opened) { opened = true; window.print(); } };
                                        const closeWin = () => { try { window.close(); } catch(e){} };

                                        window.addEventListener('load', () => setTimeout(printNow, 200));
                                        window.addEventListener('afterprint', () => setTimeout(closeWin, 200));
                                        window.addEventListener('focus', () => { if (opened) setTimeout(closeWin, 400); });
                                        })();
                                    </script>`,
                                `</body></html>`
                            ],
                            { type: 'text/html' }
                        );
                        const url = URL.createObjectURL(blob);

                        const a = document.createElement('a');
                        a.href = url;
                        a.target = '_blank';
                        a.rel = 'noopener';
                        document.body.appendChild(a);
                        a.click();
                        a.remove();

                        setTimeout(() => URL.revokeObjectURL(url), 5000);
                    }}
                    color="primary"
                    variant="contained"
                    startIcon={<PrinterIcon />}
                >
                    Print
                </Button>
                <Button variant="outlined" onClick={() => showModal(MODAL_TYPE.NONE)}>
                    Close
                </Button>
            </Box>
        </Dialog>
    );
};

export default TestItineraryModal;
